import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { useHideDirtyState } from '../../advanced-settings/providers'
import { DirtyMark } from '../../icons'

interface SectionHeaderProps {
  title: string
  righContent?: JSX.Element
  isDirty?: boolean
}

export const SectionHeading: React.FC<SectionHeaderProps> = ({ title, righContent, isDirty }) => {
  const hideDirtyState = useHideDirtyState()

  return (
    <Stack direction={'row'} mb={2} sx={{ borderBottom: theme => `1px solid ${theme.palette.divider}` }}>
      <Typography py={2} fontWeight={'bold'} variant="h2">
        {title}
      </Typography>
      {isDirty && !hideDirtyState && (
        <Box pt={1}>
          <DirtyMark />
        </Box>
      )}
      {righContent}
    </Stack>
  )
}
